var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cancel-confirm-page"},[_c('sub-header-section',{attrs:{"pageTitle":_vm.$tc('CancelPage.sectionTitle')}}),_c('cancel-confirm-pane')],1)}
var staticRenderFns = []

export { render, staticRenderFns }